export const ORDER_METHOD_VALUE = {
  CODEOffice: 'CODE office',
};
